import React, { FC } from 'react';
import { Box, Card } from '@chakra-ui/react';
import { SubtitleAndDisplayBox } from '../atom/box/SubtitleAndDisplayBox';

type Props = {
  cardTitle: string;
  cardDetail: {
    subtitle: string;
    value: string;
  }[];
};

export const ConfirmationCard: FC<Props> = (props) => {
  const { cardTitle, cardDetail } = props;

  return (
    <Box mb={7}>
      <Box fontSize={'xl'} mb={2}>
        {cardTitle}
      </Box>
      <Card>
        {cardDetail.map((item, index) => (
          <SubtitleAndDisplayBox
            key={index}
            title={item.subtitle}
            value={item.value}
          />
        ))}
      </Card>
    </Box>
  );
};
